import {
  InfoCircleOutlined,
  ExclamationCircleFilled,
  CheckCircleFilled,
  CloseCircleFilled,
} from '@ant-design/icons'
import { styled, media } from '@thesisedu/web/dist'
import { transparentize } from 'polished'
import React from 'react'

import { Content } from './Article'

const ICONS = {
  info: InfoCircleOutlined,
  warning: ExclamationCircleFilled,
  success: CheckCircleFilled,
  error: CloseCircleFilled,
}
const COLORS = {
  info: '@blue',
  warning: '@orange',
  success: '@green',
  error: '@red',
}

export function Callout({ node: { title, type, content } }) {
  const Icon = ICONS[type]
  return (
    <Container color={COLORS[type]}>
      <Heading>
        <Icon /> {title}
      </Heading>
      <Body>
        <Content content={content} />
      </Body>
    </Container>
  )
}

const Heading = styled.div`
  font-weight: bold;
  font-size: 115%;
`
const Container = styled.div`
  border-radius: ${props => props.theme['@border-radius-base']};
  padding: ${props => props.theme['@padding-sm']};
  margin-bottom: ${props => props.theme['@size-m']};
  ${media.lg} {
    padding: ${props => props.theme['@padding-lg']};
  }
  background: ${props => transparentize(0.9, props.theme[props.color])};
  ${Heading}, a {
    color: ${props => props.theme[props.color]};
  }
`
const Body = styled.div`
  *:last-child {
    margin-bottom: 0;
  }
`
